

(function ($) {

  var initialized = false;
  function init() {
    if(window.Slick === undefined) {
      window.requestAnimationFrame(init.bind(this));
      return;
    }
      
    if (!Slick.NonDataRow) {
      window.requestAnimationFrame(init.bind(this));
      return;
    }
    Slick.NonDataRow.prototype.selectedItems;
    Slick.NonDataRow.prototype.ClearSelected = function() {
      if(!this.selectedItems) {
        this.selectedItems = [];
      } else {
        this.selectedItems = [];
      }
    }
    Slick.NonDataRow.prototype.AllSelected = function() {
      return this.selectedItems.length === this.rows.length;
    }
    Slick.NonDataRow.prototype.SetSelectedFeature = function(row) {
      this.selectedItems.push(row);
    }
    Slick.NonDataRow.prototype.IsCustom = function() {
      return this.hasOwnProperty('__custom');
    }

    if (initialized === true) {
      return;
    }
    $.extend(true, window, {
      Slick: {
        Custom: {
          Rows: {
            AggTotalsRow: AggTotalsRow,
            AggGroupTotalsRow: AggGroupTotalsRow,
            AggGroupTitleRow: AggGroupTitleRow,
            GrandTotalsTitleRow: GrandTotalsTitleRow
          }
        }
      }
    });

    

    function AggGroupTotalsRow(aggName, aggLabel, group, groupInfo, level) {
      this.__custom = 'agg-group-totals-row';
      this.aggName = aggName;
      this.aggLabel = aggLabel;
      this.group = group;
      this.groupInfo = groupInfo;
      this.level = level;
      this.isSelectable = function() { return false };
    }
    AggGroupTotalsRow.prototype = new Slick.NonDataRow();

    function AggTotalsRow(aggInfo, totals) {
      this.__custom = 'agg-totals-row';
      this.aggName = aggInfo.aggName;
      this.aggLabel = aggInfo.aggLabel;
      this.totals = totals;
      this.isSelectable = function() { return false };
    }
    AggTotalsRow.prototype = new Slick.NonDataRow();

    function AggGroupTitleRow(group, groupInfo, level) {
      this.__custom = 'agg-group-title-row';
      this.group = group;
      this.groupInfo = groupInfo;
      this.level = level;
      this.isSelectable = function() { return false };
    }
    AggGroupTitleRow.prototype = new Slick.NonDataRow();

    function GrandTotalsTitleRow() {
      this.__custom = 'grand-totals-title-row';
      this.isSelectable = function() { return false };
    }
    GrandTotalsTitleRow.prototype = new Slick.NonDataRow();
    initialized = true;
  }


  init();

})(jQuery);